import { KEYBOARD_KEYS } from "@netapp/bxp-design-system-react";
import _ from "lodash";
import { useCallback } from "react";

export const useServiceCardNavigation = (config) => {
    const {
        index,
        totalServices,
        favoriteButtonRef,
        navLinkRef,
        onKeyDown = _.noop,
        onToggleFavorite = _.noop,
        onNavigate = _.noop
    } = config;

    const handleFavoriteKeyDown = useCallback((e) => {
        const { key } = e;
        
        switch (key) {
            case KEYBOARD_KEYS.TAB:
                if (!e.shiftKey) {
                    e.preventDefault();
                    navLinkRef.current?.focus();
                } else if (index === 0) {
                    e.preventDefault();
                    onKeyDown(e, index);
                }
                break;

            case KEYBOARD_KEYS.ARROW_DOWN:
            case KEYBOARD_KEYS.ARROW_UP:
                e.preventDefault();
                onKeyDown(e, index);
                break;

            case KEYBOARD_KEYS.ENTER:
            case KEYBOARD_KEYS.SPACE_BAR:
            case KEYBOARD_KEYS.SPACE_BAR_ALTERNATIVE:
                e.preventDefault();
                onToggleFavorite();
                break;

            case KEYBOARD_KEYS.ARROW_LEFT:
                e.preventDefault();
                onKeyDown(e, index);
                break;

            default:
                break;
        }
    }, [index, navLinkRef, onKeyDown, onToggleFavorite]);

    const handleNavLinkKeyDown = useCallback((e) => {
        const { key } = e;
        
        switch (key) {
            case KEYBOARD_KEYS.TAB:
                if (e.shiftKey) {
                    e.preventDefault();
                    favoriteButtonRef.current?.focus();
                } else if (index === totalServices - 1) {
                    e.preventDefault();
                    onKeyDown(e, index);
                }
                break;

            case KEYBOARD_KEYS.ARROW_DOWN:
            case KEYBOARD_KEYS.ARROW_UP:
                e.preventDefault();
                onKeyDown(e, index);
                break;

            case KEYBOARD_KEYS.ARROW_LEFT:
                e.preventDefault();
                onKeyDown(e, index);
                break;

            case KEYBOARD_KEYS.ENTER:
                e.preventDefault();
                onNavigate();
                navLinkRef.current?.click();
                break;
            default:
                break;
        }
    }, [index, totalServices, favoriteButtonRef, onKeyDown, onNavigate, navLinkRef]);

    return {
        handleFavoriteKeyDown,
        handleNavLinkKeyDown
    };
};
